import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { Button } from "../components/ui/button";
import { LOGO_URL } from "../lib/assets";

const AuthShell = ({ title, subtitle, children }) => (
  <div className="pt-16 min-h-screen flex items-center justify-center relative overflow-hidden">
    <div className="absolute inset-0 hero-glow" />
    <div className="absolute inset-0 grid-lines opacity-30" />
    <div className="relative w-full max-w-md px-5 py-16">
      <div className="bg-[#0f1116] border border-white/8 rounded-2xl p-8">
        <div className="text-center mb-8">
          <img src={LOGO_URL} alt="ScoutOS" className="w-14 h-14 rounded-2xl object-cover mx-auto mb-4 shadow-lg shadow-blue-500/20" />
          <h1 className="font-display text-2xl font-bold text-white">{title}</h1>
          <p className="text-gray-500 text-sm mt-1">{subtitle}</p>
        </div>
        {children}
      </div>
    </div>
  </div>
);

const GoogleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24">
    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" />
    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
  </svg>
);

const Login = () => {
  const { t, user, loginWithGoogle } = useApp();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) navigate("/dashboard");
  }, [user, navigate]);

  return (
    <AuthShell title={t.auth.loginTitle} subtitle={t.auth.loginSubtitle}>
      <Button
        onClick={loginWithGoogle}
        className="w-full bg-white hover:bg-gray-100 text-gray-800 h-12 rounded-xl font-medium flex items-center justify-center gap-3"
      >
        <GoogleIcon /> Continue with Google
      </Button>
      <p className="text-center text-xs text-gray-600 mt-6 leading-relaxed">
        By continuing you agree to the Terms of Service and Privacy Policy.
      </p>
    </AuthShell>
  );
};

export default Login;
export { AuthShell };
